(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accessibility-enhancements"] && !Shopify.designMode) return;
  try {
    // Add titles to iframes that don't have them (for Shopify-injected content)
  // Deferred to avoid blocking initial render
  (function() {
    'use strict';
    function addIframeTitles() {
      const iframes = document.querySelectorAll('iframe:not([title]):not([aria-label])');
      iframes.forEach(function(iframe) {
        // Try to determine context from parent or src
        let title = 'Embedded content';
        
        if (iframe.src) {
          if (iframe.src.includes('shop.app') || iframe.src.includes('shopify')) {
            title = 'Shopify application content';
          } else if (iframe.src.includes('payment') || iframe.src.includes('checkout')) {
            title = 'Payment processing';
          } else if (iframe.src.includes('analytics') || iframe.src.includes('tracking')) {
            title = 'Analytics content';
          }
        }
        
        iframe.setAttribute('title', title);
      });
    }
    
    // Defer execution until after initial render
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        requestIdleCallback ? requestIdleCallback(addIframeTitles) : setTimeout(addIframeTitles, 100);
      });
    } else {
      requestIdleCallback ? requestIdleCallback(addIframeTitles) : setTimeout(addIframeTitles, 100);
    }
    
    // Run after a delay to catch dynamically added iframes
    setTimeout(addIframeTitles, 2000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["js-utils"] && !Shopify.designMode) return;
  try {
    // Shared utility functions - loaded once, used everywhere
  // Deferred to avoid blocking render
  (function() {
    'use strict';
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initUtils);
    } else {
      setTimeout(initUtils, 0);
    }
    
    function initUtils() {
      window.ThemeUtils = window.ThemeUtils || {
    // Debounce function for performance
    debounce: function(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },
    
    // Throttle function for scroll/resize events
    throttle: function(func, limit) {
      let inThrottle;
      return function(...args) {
        if (!inThrottle) {
          func.apply(this, args);
          inThrottle = true;
          setTimeout(() => inThrottle = false, limit);
        }
      };
    },
    
    // Check if element is in viewport (for lazy loading)
    isInViewport: function(element) {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    
    // Lazy load script
    loadScript: function(src, callback) {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      if (callback) script.onload = callback;
      document.head.appendChild(script);
    },
    
    // Event delegation helper
    delegate: function(selector, event, handler) {
      document.addEventListener(event, function(e) {
        const target = e.target.closest(selector);
        if (target) handler.call(target, e);
      });
    },
    
    // Safe querySelector with early return
    safeQuery: function(selector, context) {
      const ctx = context || document;
      return ctx.querySelector(selector);
    },
    
    // Safe querySelectorAll with early return
    safeQueryAll: function(selector, context) {
      const ctx = context || document;
      return Array.from(ctx.querySelectorAll(selector));
    }
      };

      // Header fallback:
      // If the block-based header script fails to initialize for any reason, provide a minimal
      // implementation so mobile menus still work.
      try {
        initHeaderFallback();
      } catch (e) {
        // Header fallback initialization failed
      }
    }

    function initHeaderFallback() {
      if (window.__catchyHeader && window.__catchyHeader.status === 'ready') return;

      const header = document.querySelector('[data-header]');
      if (!header) return;

      const mobileMenu = document.querySelector('[data-mobile-menu]');

      const getHeaderBottom = function() {
        const headerMain = document.querySelector('.header__main');
        if (headerMain) return headerMain.getBoundingClientRect().bottom;

        return header.getBoundingClientRect().bottom;
      };

      const setToggleAria = function(selectors, expanded) {
        const nodes = document.querySelectorAll(selectors.join(','));
        nodes.forEach(btn => btn.setAttribute('aria-expanded', expanded ? 'true' : 'false'));
      };

      const isMenuOpen = function(menu, key) {
        if (!menu || !menu.dataset) return false;
        return menu.dataset[key] === 'true' || menu.dataset[key] === 'True';
      };

      const closeAllMenus = function() {
        if (mobileMenu && mobileMenu.dataset) mobileMenu.dataset.mobileMenuOpen = 'false';
        setToggleAria(['[data-mobile-menu-toggle]'], false);
      };

      const openMenu = function(menu, key) {
        if (!menu || !menu.dataset) return;
        menu.dataset[key] = 'true';
        setToggleAria(['[data-mobile-menu-toggle]'], true);

        // Position below visible header
        const top = getHeaderBottom();
        if (top > 0) menu.style.top = top + 'px';
      };

      const toggleMenu = function(menu, key) {
        if (!menu || !menu.dataset) return;
        const open = isMenuOpen(menu, key);
        if (open) {
          menu.dataset[key] = 'false';
          setToggleAria(['[data-mobile-menu-toggle]'], false);
          menu.style.top = '';
        } else {
          // Close other menu first
          if (menu !== mobileMenu && mobileMenu && mobileMenu.dataset) {
            mobileMenu.dataset.mobileMenuOpen = 'false';
            mobileMenu.style.top = '';
          }
          openMenu(menu, key);
        }
      };


      // Click handling (capture to match header script behavior)
      document.addEventListener('click', function(e) {
        const toggle = e.target.closest('[data-mobile-menu-toggle]');
        if (toggle) {
          e.preventDefault();
          if (mobileMenu) {
            toggleMenu(mobileMenu, 'mobileMenuOpen');
          }
          return;
        }

        const submenuToggle = e.target.closest('[data-mobile-submenu-toggle]');
        if (submenuToggle) {
          e.preventDefault();
          const item = submenuToggle.closest('.header__mobile-menu-item');
          if (item && item.dataset) {
            const open = item.dataset.mobileSubmenuOpen === 'true';
            item.dataset.mobileSubmenuOpen = String(!open);
          }
          return;
        }

        const anyOpen = isMenuOpen(mobileMenu, 'mobileMenuOpen');
        if (!anyOpen) return;

        const clickedInside = e.target.closest('[data-mobile-menu], [data-mobile-menu-toggle]');
        if (!clickedInside) closeAllMenus();
      }, true);

      // Escape to close
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeAllMenus();
      });

    }
  })();
  } catch(e) { console.error(e); }
})();

})();
